
import React, { useEffect, useState } from "react";
//import axios from '../../../node_modules-back/axios';
import axios from 'axios'
//import { useForm } from '../../../node_modules-back/react-hook-form/dist';
import { useForm } from 'react-hook-form';
import { getUrl } from "../../ApiCall/GetUrl";


import Footer from "../Footer/Footer";
// Importación de los estilos
import "../../styles/Admin.css"

export default function LawyerTable(){
  
  const [abogados, setAbogados] = useState([]);
  useEffect(() => {
    axios.get(getUrl() + "/get_all_lawyer").then(response => {
      setAbogados(response.data);
      console.log("Este es el response.data de clientes: ", response.data)
    }).catch(error => {
      console.log("Error fetching data de clientes: ", error); 
      setAbogados(["Hubo un error al obtener la información"])
    });
  }, [])
  var cont = 0;

  return <>
      <div className="container mt-5 mb-5">
        <div className="tabla">
          <table>
            <thead>
              <tr>
                <th>Posición</th>
                <th>Correo</th>
                <th>Tipo de Persona</th>
                <th>Nombre</th>
                <th>Número Telefónico</th>
                <th>Género</th>
                <th>Ocupación</th>
              </tr>
            </thead>
            <tbody>
                {abogados.map(row => <tr>
                    <td className="pos">{++cont}</td>
                    <td>{row.client_email}</td>
                  </tr>
              )
              }
            </tbody>
          </table>
        </div>        
      </div>
    </>
}
